export default {
  ALL: '',
  OPEN: 'OPEN',
  CANCELED: 'CANCELED',
  FILLED: 'FILLED',
  PARTIAL_FILLED: 'PARTIAL_FILLED',
  PENDING: 'PENDING',
  TRANSACTIONS: 'TRANSACTIONS',
  TX_SEND: 'TX_SEND',
  TX_RECEIVE: 'TX_RECEIVE',
};
